export const BASE_URL = process.env.REACT_APP_API_URL || 'http://api.tripze.vn:8080';
export const BASE_IMAGE_URL = process.env.REACT_APP_IMAGE_URL || 'https://ct7solutions.com/';
export const REACT_APP_YOUTUBE_URL = process.env.REACT_APP_YOUTUBE_URL || 'http://ct7solutions.com';
export const REACT_APP_TWITTER_URL = process.env.REACT_APP_TWITTER_URL || 'http://ct7solutions.com';
export const REACT_APP_FACEBOOK_URL = process.env.REACT_APP_FACEBOOK_URL || 'http://ct7solutions.com';
export const REACT_APP_APP_STORE_URL = process.env.REACT_APP_APP_STORE_URL || 'http://ct7solutions.com';
export const REACT_APP_GOOGLE_PLAY_URL = process.env.REACT_APP_GOOGLE_PLAY_URL || 'http://ct7solutions.com';

export const CLIENT_GOOGLE_ID = process.env.REACT_APP_CLIENT_GOOGLE_ID 
export const FACEBOOK_ID = process.env.REACT_APP_CLIENT_FACEBOOK_ID
export const MAP_API_KEY = process.env.REACT_APP_MAP_API_KEY
export const MAP_API_VERSION = process.env.REACT_APP_MAP_API_VERSION
export const API_GET_REGION = process.env.REACT_APP_URL_API_GET_REGION
export const PAGING_SIZE_DEFAULT = 20
export const REACT_APP_OSM_API_URL = process.env.REACT_APP_OSM_API_URL